module.exports = __webpack_public_path__ + "static/media/acorn-header.06603fb8.png";